/**
 * EN-4200: the V2 Storage Providers responses. The API answers the legacy URLs
 * with `source: 'v2'` for accounts on the storage_providers_page_v2 switch;
 * the pages tell the two apart by that field. The shapes are the zod contract
 * in packages/api-contracts (core/storage-providers).
 */

export type {
  StorageProviderV2Warehouse,
  StorageProviderV2Row,
  StorageProviderV2ListResponse,
  StorageProviderV2Provider,
  StorageProviderV2Node,
  StorageProviderV2HealthEvent,
  StorageProviderV2Detail,
  StorageProviderV2InventoryWarehouse,
  StorageProviderV2InventoryItem,
  StorageProviderV2InventoryResponse,
  StorageProviderV2NodeAddress,
} from '@skupreme/api-contracts/core';

/** True for a V2 response, either shape; a legacy response has no `source`. */
export const isV2Response = <T extends { source: 'v2' }>(
  response: unknown,
): response is T =>
  (response as { source?: string } | null | undefined)?.source === 'v2';
